if (!customElements.get("m-blog-post-slider")) {
  class MBlogPostSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.initDesktopGrid();
      this.initMobileSlider();
      this.handleResize();
    }

    initDesktopGrid() {
      const grid = this.querySelector('.m-blog-grid');
      if (!grid) return;

      const count = grid.querySelectorAll('.m-blog-card').length;
      grid.setAttribute('data-count', count);
    }

    initMobileSlider() {
      // Solo inicializar en mobile
      if (window.innerWidth >= 768) return;

      if (!this.querySelector('.m-blog-slider')) return;

      const autoplay = this.dataset.autoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      
      if (slideContainer && typeof MinimogLibs !== 'undefined' && MinimogLibs.Swiper) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          autoplay: autoplay ? {
            delay: parseInt(autoplaySpeed) * 1000,
            disableOnInteraction: false,
          } : false,
          loop: false,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }

    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const isMobile = window.innerWidth < 768;
          
          // Destruir slider si estamos en desktop
          if (!isMobile && this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
          }
          
          // Inicializar slider si estamos en mobile y no existe
          if (isMobile && !this.slider && this.querySelector('.m-blog-slider')) {
            this.initMobileSlider();
          }
        }, 250);
      });
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy(true, true);
      }
    }
  }

  customElements.define("m-blog-post-slider", MBlogPostSlider);
}